import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ChartBarModel } from '../../models/chart.model';

@Component({
  selector: 'app-chart-bar',
  templateUrl: './chart-bar.component.html',
  styleUrls: ['chart-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartBarComponent {
  @Input() barModel: ChartBarModel;
  @Input() tileHeight = 200;
  @Input() maxBarHeight = (this.tileHeight * 84) / 100; // height- 16% margin
  @Input() selectedRangeMaxValue: number = this.maxBarHeight;
  @Input() hideDesignationKey = false;

  getHeight(barChartPartValue: number): number {
    return (barChartPartValue * this.maxBarHeight) / this.selectedRangeMaxValue;
  }
}
